import React, { useState } from "react";
import axiosInstance from "../Request";
import { URL } from "../api";
import { toast } from "react-toastify"; // ✅ add karo

const HelpSupportButton = () => {
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({
    senderEmail: "",
    subject: "",
    body: "",
  });
  const [loading, setLoading] = useState(false);

  const fintechId = localStorage.getItem("fintechId");
  const receiverEmail = "abhinavgahlaut1379@gmail.com";

  const handleOpen = () => {
    setShowModal(true);
    setForm({ senderEmail: "", subject: "", body: "" });
  };

  const handleSubmit = async () => {
    if (!form.senderEmail || !form.subject || !form.body) {
      toast.error("Please fill all fields"); // ✅ alert ki jagah toast
      return;
    }

    setLoading(true);
    try {
      await axiosInstance.post(URL.SUPPORT_CONTACT, {
        fintechId: fintechId ? Number(fintechId) : null,
        senderEmail: form.senderEmail,
        subject: form.subject,
        body: form.body,
      });

      setShowModal(false);
      setForm({ senderEmail: "", subject: "", body: "" });
      toast.success("Request submitted successfully !"); // ✅ top-right toast

    } catch (err) {
      console.error("Support API error:", err);
      if (err.response?.status === 401) {
        toast.error("Session expired. Please login again.");
      } else {
        toast.error("Failed to submit. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <button onClick={handleOpen} style={styles.floatingBtn}>
        <svg
          width="15"
          height="15"
          viewBox="0 0 24 24"
          fill="none"
          stroke="white"
          strokeWidth="2"
          style={{ marginRight: 7, verticalAlign: "middle" }}
        >
          <path d="M3 18v-6a9 9 0 0 1 18 0v6" />
          <path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3z" />
          <path d="M3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z" />
        </svg>
        Help & Support
      </button>

      {showModal && (
        <div style={styles.overlay}>
          <div style={styles.modal}>

            <div style={styles.modalHeader}>
              <div style={styles.headerLeft}>
                <div style={styles.headerIcon}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                    <path d="M3 18v-6a9 9 0 0 1 18 0v6" />
                    <path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3z" />
                    <path d="M3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z" />
                  </svg>
                </div>
                <div>
                  <p style={styles.headerTitle}>Help & Support</p>
                  <p style={styles.headerSub}>We typically reply within 24 hours</p>
                </div>
              </div>
              <div style={styles.closeBtn} onClick={() => setShowModal(false)}>
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="white" strokeWidth="2">
                  <line x1="1" y1="1" x2="11" y2="11" />
                  <line x1="11" y1="1" x2="1" y2="11" />
                </svg>
              </div>
            </div>

            <div style={styles.modalBody}>

              <div style={styles.receiverBox}>
                <div style={styles.receiverIconBox}>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                    <polyline points="22,6 12,13 2,6" />
                  </svg>
                </div>
                <div>
                  <p style={styles.receiverLabel}>Write to us directly</p>
                  <p style={styles.receiverEmail}>{receiverEmail}</p>
                </div>
              </div>

              <div style={styles.fieldGroup}>
                <label style={styles.label}>Your Email</label>
                <div style={styles.inputWrapper}>
                  <svg style={styles.inputIcon} width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#999" strokeWidth="2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                    <polyline points="22,6 12,13 2,6" />
                  </svg>
                  <input
                    style={styles.input}
                    placeholder="yourmail@example.com"
                    type="email"
                    value={form.senderEmail}
                    onChange={(e) => setForm({ ...form, senderEmail: e.target.value })}
                  />
                </div>
              </div>

              <div style={styles.fieldGroup}>
                <label style={styles.label}>Subject</label>
                <div style={styles.inputWrapper}>
                  <svg style={styles.inputIcon} width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#999" strokeWidth="2">
                    <line x1="8" y1="6" x2="21" y2="6" />
                    <line x1="8" y1="12" x2="21" y2="12" />
                    <line x1="8" y1="18" x2="21" y2="18" />
                    <line x1="3" y1="6" x2="3.01" y2="6" />
                    <line x1="3" y1="12" x2="3.01" y2="12" />
                    <line x1="3" y1="18" x2="3.01" y2="18" />
                  </svg>
                  <input
                    style={styles.input}
                    placeholder="e.g. Payment Issue"
                    value={form.subject}
                    onChange={(e) => setForm({ ...form, subject: e.target.value })}
                  />
                </div>
              </div>

              <div style={styles.fieldGroup}>
                <label style={styles.label}>Describe your issue</label>
                <textarea
                  style={styles.textarea}
                  placeholder="Please describe your issue in detail..."
                  value={form.body}
                  onChange={(e) => setForm({ ...form, body: e.target.value })}
                />
              </div>

              {fintechId && (
                <div style={styles.fintechTag}>
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="2" style={{ marginRight: 6, verticalAlign: "middle" }}>
                    <rect x="3" y="3" width="18" height="18" rx="2" />
                    <path d="M3 9h18M9 21V9" />
                  </svg>
                  <span style={styles.fintechLabel}>Fintech ID:</span>
                  <strong style={styles.fintechValue}>{fintechId}</strong>
                </div>
              )}
            </div>

            <div style={styles.modalFooter}>
              <button onClick={handleSubmit} style={styles.submitBtn} disabled={loading}>
                {loading ? (
                  "Submitting..."
                ) : (
                  <>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" style={{ marginRight: 7, verticalAlign: "middle" }}>
                      <line x1="22" y1="2" x2="11" y2="13" />
                      <polygon points="22 2 15 22 11 13 2 9 22 2" />
                    </svg>
                    Submit
                  </>
                )}
              </button>
              <button onClick={() => setShowModal(false)} style={styles.cancelBtn}>
                Cancel
              </button>
            </div>

          </div>
        </div>
      )}
    </div>
  );
};

const styles = {
  floatingBtn: {
    position: "fixed",
    bottom: "28px",
    right: "28px",
    backgroundColor: "#172b4d",
    color: "#fff",
    padding: "11px 20px",
    border: "none",
    borderRadius: "50px",
    cursor: "pointer",
    fontSize: "13px",
    fontWeight: "500",
    boxShadow: "0 4px 16px rgba(0,0,0,0.25)",
    zIndex: 99999,
    display: "flex",
    alignItems: "center",
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0,0,0,0.45)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 999999,
  },
  modal: {
    backgroundColor: "#fff",
    borderRadius: "14px",
    width: "430px",
    border: "0.5px solid #e0e0e0",
    overflow: "hidden",
  },
  modalHeader: {
    backgroundColor: "#172b4d",
    padding: "16px 20px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  headerIcon: {
    width: "34px",
    height: "34px",
    borderRadius: "50%",
    backgroundColor: "rgba(255,255,255,0.15)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  headerTitle: {
    margin: 0,
    color: "#fff",
    fontSize: "14px",
    fontWeight: "500",
  },
  headerSub: {
    margin: 0,
    color: "rgba(255,255,255,0.55)",
    fontSize: "11px",
  },
  closeBtn: {
    width: "28px",
    height: "28px",
    borderRadius: "50%",
    backgroundColor: "rgba(255,255,255,0.1)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  },
  modalBody: {
    padding: "20px 22px 8px",
  },
  receiverBox: {
    backgroundColor: "#f8f9fa",
    border: "0.5px solid #e8e8e8",
    borderRadius: "10px",
    padding: "12px 14px",
    marginBottom: "18px",
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  receiverIconBox: {
    width: "34px",
    height: "34px",
    borderRadius: "50%",
    backgroundColor: "#172b4d",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  receiverLabel: {
    margin: 0,
    fontSize: "11px",
    color: "#888",
  },
  receiverEmail: {
    margin: 0,
    fontSize: "13px",
    fontWeight: "500",
    color: "#172b4d",
  },
  fieldGroup: {
    marginBottom: "14px",
  },
  label: {
    display: "block",
    fontSize: "11px",
    fontWeight: "500",
    color: "#888",
    marginBottom: "6px",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  inputWrapper: {
    position: "relative",
  },
  inputIcon: {
    position: "absolute",
    left: "11px",
    top: "50%",
    transform: "translateY(-50%)",
    pointerEvents: "none",
  },
  input: {
    width: "100%",
    padding: "9px 12px 9px 34px",
    borderRadius: "8px",
    border: "0.5px solid #ddd",
    fontSize: "13px",
    boxSizing: "border-box",
    outline: "none",
    fontFamily: "inherit",
    color: "#333",
    backgroundColor: "#fff",
  },
  textarea: {
    width: "100%",
    padding: "9px 12px",
    borderRadius: "8px",
    border: "0.5px solid #ddd",
    fontSize: "13px",
    boxSizing: "border-box",
    outline: "none",
    fontFamily: "inherit",
    height: "88px",
    resize: "none",
    color: "#333",
    backgroundColor: "#fff",
    lineHeight: "1.5",
  },
  fintechTag: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "#f8f9fa",
    border: "0.5px solid #e8e8e8",
    borderRadius: "8px",
    padding: "8px 12px",
    marginTop: "4px",
    marginBottom: "4px",
  },
  fintechLabel: {
    fontSize: "12px",
    color: "#888",
    marginRight: "5px",
  },
  fintechValue: {
    fontSize: "12px",
    color: "#333",
    fontWeight: "500",
  },
  modalFooter: {
    padding: "14px 22px 20px",
    display: "flex",
    gap: "10px",
  },
  submitBtn: {
    flex: 1,
    padding: "10px 14px",
    backgroundColor: "#172b4d",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "13px",
    fontWeight: "500",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  cancelBtn: {
    padding: "10px 18px",
    backgroundColor: "#f5f5f5",
    color: "#555",
    border: "0.5px solid #ddd",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "13px",
  },
};

export default HelpSupportButton;